
'use strict';
const	ComponentFactory	= require('factories/Component')
        , React             = require('react')
        , style		        = require('./style')
        ;

module.exports = ComponentFactory.create({
    displayName : 'PopupBasic',
    render : function(){
        return (
            <div id="popupblockerbasic">
                <div className="modal-backdrop" onClick={this.props.closePopup}></div>
                <div className="modal">
                    <div className="popupblockerbasic">
                        <div className="popupblockerbasic__content">
                            <h3 className="popupblockerbasic__title">{this.props.title}</h3>
                            <p className="popupblockerbasic__description" dangerouslySetInnerHTML={{__html: this.props.content}}></p>
                            
                            <div className="popupblockerbasic__button-container">
                                <button className="popupblockerbasic__button popupblockerbasic__button--outline" onClick={this.props.closePopup}>
                                    {this.props.leftButton}
                                </button>
                                <a className="popupblockerbasic__button popupblockerbasic__button--fill" href={this.props.targetUrl} >
                                    {this.props.rightButton}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});
            


// WEBPACK FOOTER //
// resources/modules/components/popup/basic/component.jsx